










































import { Component } from 'vue-property-decorator';
import RouterAndStringMixin from "@/utils/CommonMixin";
import cr from "@/CompositionRoot";
import _ from "lodash";
import { ImageInfo, ImageInfos } from "frontend-common";
import InlineImageUpload from "@/components/dashboard/common/InlineImageUpload.vue";
import ImagesGrid from "@/components/dashboard/ImagesGrid.vue";

@Component({
    components: { InlineImageUpload, ImagesGrid },
})
export default class extends RouterAndStringMixin {

    mounted() {
        const route = this.$route
        const refs = this.$refs
        setTimeout(function () {
            if (!route.meta?.fromHistory) {
                (refs.add as HTMLElement).focus()
            }
        }, 100)
    }

    get images(): ImageInfos {
        return cr.organizationModule.images
    }

    isEmpty(): boolean {
        return _.isEmpty(this.images)
    }

    onImageUploaded() {
        this.$bvModal.hide("upload-image")
        const title = this.$t("dashboard.image.upload.actionUpload") as string
        const message = this.$t("dashboard.image.upload.actionSuccess") as string
        this.showToast(title, message, "success")
    }

    onImageUploadCancelled() {
        this.$bvModal.hide("upload-image")
    }

    onImageClicked(image: ImageInfo) {
        this.$router.push(this.toOrganizationImage(image.id))
    }
}
